import { render, staticRenderFns } from "./departmentChooserDialog.vue?vue&type=template&id=467511ec&scoped=true&"
import script from "./departmentChooserDialog.vue?vue&type=script&lang=js&"
export * from "./departmentChooserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467511ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('467511ec')) {
      api.createRecord('467511ec', component.options)
    } else {
      api.reload('467511ec', component.options)
    }
    module.hot.accept("./departmentChooserDialog.vue?vue&type=template&id=467511ec&scoped=true&", function () {
      api.rerender('467511ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/departmentChooserDialog.vue"
export default component.exports